import React from "react";
import "../CTASection.css";

import {
  FaArrowRight,
  FaPhoneAlt,
  FaCheckCircle,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const CTASection = () => {
  return (
    <section className="cta">

      <div className="cta-bg-circle circle1"></div>
      <div className="cta-bg-circle circle2"></div>

      <div className="cta-container">

        <span className="cta-tag">
          LET'S BUILD THE FUTURE TOGETHER
        </span>

        <h2>
          Ready to Transform Your
          <span> Business with Technology?</span>
        </h2>

        <p>
          Whether you're launching a startup, modernizing enterprise software,
          adopting AI, or accelerating digital transformation, VisionVote
          Technologies is here to turn your ideas into scalable digital
          solutions. Let's build innovative technology that drives measurable
          business success.
        </p>

        <div className="cta-buttons">

          <button className="primary-btn">
          <a href="/contact" style={{ textDecoration: "none", color: "inherit" }}>
            Schedule a Consultation
          </a>
            <FaArrowRight />
          </button>

          <button className="secondary-btn">
          <a href="/contact" style={{ textDecoration: "none", color: "inherit" }}>
          Contact Us
          </a>
            <FaPhoneAlt />
            
          
          </button>

        </div>

        <div className="home-cta-features">

          <div>
            <FaCheckCircle />
            <span>Free Consultation</span>
          </div>

          <div>
            <FaCheckCircle />
            <span>Transparent Communication</span>
          </div>

          <div>
            <FaCheckCircle />
            <span>End-to-End Support</span>
          </div>

          <div>
            <FaCheckCircle />
            <span>Future-Ready Solutions</span>
          </div>

        </div>

      </div>

    </section>
  );
};

export default CTASection;